import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ButtonSeverity} from 'primeng/types/button';

export type AeButtonVariant = 'primary' | 'danger' | 'warning' | 'success' | 'plain';

@Component({
  selector: 'app-ae-button',
  templateUrl: './ae-button.component.html',
  standalone: false
})
export class AeButtonComponent {

  @Input() label?: string;
  @Input() icon?: string;
  @Input() loading = false;
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  /** primary=blue, danger=red, warning=amber, success=green, plain=gray */
  @Input() variant: AeButtonVariant = 'primary';
  /** Classes extra (ex.: w-full, mx-auto) */
  @Input() styleClass = '';
  /** sm = p-button-sm (compacto) */
  @Input() size: 'sm' | 'md' = 'md';

  @Output() buttonClick = new EventEmitter<Event>();

  get severity(): ButtonSeverity {
    const map: Record<AeButtonVariant, ButtonSeverity> = {
      primary: 'primary',
      danger: 'danger',
      warning: 'warn',
      success: 'success',
      plain: 'secondary'
    };
    return map[this.variant];
  }

  get mergedStyleClass(): string {
    const size = this.size === 'sm' ? 'p-button-sm' : '';
    return [size, this.styleClass].filter(Boolean).join(' ').trim();
  }

  handlePrimeClick(ev: Event): void {
    this.buttonClick.emit(ev);
  }
}
